import { Box } from '@mui/material'
import GameTypeAndStatus from './GameTypeAndStatus'
import GameFormCTAButtons from './CommonLayout/GameFormCTAButtons'

const GameContainer = ({ formGameData, showsList, setFormGameData, handleChange }) => {
    return (
        <Box display={"flex"} flex={1} flexDirection="column" gap={2}>
            <GameTypeAndStatus formGameData={formGameData} showsList={showsList} setFormGameData={setFormGameData} handleChange={handleChange} />
            {formGameData?.type && <GameFormCTAButtons formGameData={formGameData} handleChange={handleChange} />}
        </Box>
    )
}

export default GameContainer
